import React from 'react'
import { connect } from 'react-redux'
import { Dispatch, AnyAction } from 'redux'
import { RootStoreState } from '../../root/index'
import { CollectionItem, Collection, ScreenSection } from '../../api/types'
import { loadMapRoutes } from '../actions'
import { loadMediaItem } from '../../..'
import { MediaItemsStoreState } from '../../mediaitems/types'
import { KeypadEntryStatus, KeypadItem } from '../../scanner/types'
import { MapRoute } from 'mytours-read-api-typescript'

/**
 * Defines the props that this container requires to render the map
 */
export interface OwnProps {
	details: Collection | ScreenSection
	linkedType: MapRoute.LinkedTypeEnum
	items: CollectionItem[]
	currentItemIndex: number
	isMapLayout?: boolean
	onCloseMap: () => void
	boundAll?: boolean
	setCurrentPage?: (pageIndex: number) => void
	onItemNavigate?: (item: CollectionItem | ScreenSection) => void
	keypadEnabled?: boolean
}

export interface Props {
	details: Collection | ScreenSection
	linkedType: MapRoute.LinkedTypeEnum
	items: CollectionItem[]
	currentItemIndex: number
	isMapLayout?: boolean
	onCloseMap: () => void
	boundAll?: boolean
	setCurrentPage?: (pageIndex: number) => void
	onItemNavigate?: (item: CollectionItem | ScreenSection) => void
	keypadEnabled?: boolean
	mapRoutes?: any[]
	keypadEntryStatus?: KeypadEntryStatus
	keypadEntryItems: KeypadItem[]
	keypadEntryLoading: boolean
	mediaItems: MediaItemsStoreState
}

export interface Actions {
	loadMapRoutes: (item: Collection | ScreenSection, linkedType: MapRoute.LinkedTypeEnum, language: string, accountId?: number) => void
	loadMediaItem: (id: number, version: number, language: string) => void
}

// NB had to extend ContainerOwnProps as was getting TS error for web
const mapStateToProps = <P extends OwnProps>(state: RootStoreState, ownProps: P): Props => {
	const mapRoutes = Array.from(state.map.mapRoutes.values()).filter(
		item => item.attributes.linkedId === ownProps.details.id && item.attributes.linkedType === ownProps.linkedType,
	)

	return {
		...ownProps,
		mapRoutes,
		keypadEntryStatus: state.scanner.keypadEntryStatus,
		keypadEntryItems: state.scanner.items,
		keypadEntryLoading: state.scanner.loading,
		mediaItems: state.mediaitems.mediaItems,
	}
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): Actions => ({
	loadMapRoutes: (item: Collection | ScreenSection, linkedType: MapRoute.LinkedTypeEnum, language: string, accountId?: number) => {
		dispatch(loadMapRoutes({ item, linkedType, language, accountId }))
	},
	loadMediaItem: (id: number, version: number, language: string) => {
		dispatch(loadMediaItem({ id, version, language }))
	},
})

export default (Component: React.ComponentType<Props & Actions>) => connect(mapStateToProps, mapDispatchToProps)(Component)
